import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/layout/ScrollToTop';
import PopupManager from './components/layout/PopupManager';
import PageTracker from './components/layout/PageTracker';
import Home from './pages/Home';
import Loan from './pages/Loan';
import ProtectCredit from './pages/ProtectCredit';
import BuildCredit from './pages/BuildCredit';
import HowItWorks from './pages/HowItWorks';
import Faq from './pages/Faq';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './lib/AuthContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOffers from './pages/admin/AdminOffers';
import AdminPopups from './pages/admin/AdminPopups';
import AdminSubmissions from './pages/admin/AdminSubmissions';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import RequireAdmin from './pages/admin/RequireAdmin';
import Unsubscribe from './pages/Unsubscribe';
import CloakedRedirect from './pages/CloakedRedirect';
import AdminAccess from './pages/admin/AdminAccess';
import AdminShortLinks from './pages/admin/AdminShortLinks';
import AdminJourney from './pages/admin/AdminJourney';
import AccessGuard from './components/layout/AccessGuard';
import { useLocation } from 'react-router-dom';

function PublicLayout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isStandalone = location.pathname === '/unsubscribe' || location.pathname.startsWith('/track/');
  const hideChrome = isAdmin || isStandalone;
  return (
    <>
      {!hideChrome && <Navbar />}
      <PageTracker />
      <main>{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <PopupManager />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AccessGuard>
          <PublicLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/loan" element={<Loan />} />
              <Route path="/protect-credit" element={<ProtectCredit />} />
              <Route path="/build-credit" element={<BuildCredit />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/track/:slug" element={<CloakedRedirect />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                <Route index element={<AdminDashboard />} />
                <Route path="offers" element={<AdminOffers />} />
                <Route path="popups" element={<AdminPopups />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="short-links" element={<AdminShortLinks />} />
                <Route path="journey" element={<AdminJourney />} />
                <Route path="access" element={<AdminAccess />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </PublicLayout>
          </AccessGuard>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
